import Positionnable from './interfaces/Positionnable'

export default class NoMiningZone implements Positionnable {
    public x = 0
    public y = 0

    public radius = 0
}
